export const brand = 'El Código de Autoridad'

export const heroPromise = 'Después de esto, ves el juego que otros no ven.'

export const heroTrust: string[] = [
  '8.500+ Profesionales en Argentina',
  '4.9★ de 2.340 reseñas verificadas',
  'Acceso inmediato y de por vida',
]

export const heroCta = 'Acceder a la oferta de lanzamiento'

export const heroQuote =
  'Antes entraba a las reuniones enfocado en mis números. Hoy entro analizando personas. El verdadero cambio fue aprender a ver lo que estaba escondido a plena vista.'

export const heroQuoteIntro = 'Un director comercial me lo dijo hace poco:'

export const heroSubtitle =
  'Eso cambió absolutamente todo para él. Y cambia todo para cualquiera que entienda estas 48 leyes de verdad.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '8.500+', label: 'Profesionales en Argentina' },
  { value: '4.9★', label: 'De 2.340 reseñas verificadas' },
  { value: 'De por vida', label: 'Acceso inmediato, pago único' },
]

export interface Problem {
  title: string
  detail: string
}

export const problemsTitle =
  '¿Cuántas oportunidades has perdido por no entender cómo funciona el poder real?'

export const problems: Problem[] = [
  {
    title: 'Entrás a una reunión sin saber el "juego" real',
    detail:
      'Todos hablan del temario, pero el poder se mueve en otra dirección. ¿Dónde? Si no lo ves, estás en desventaja desde el primer minuto.',
  },
  {
    title: 'Te sabotean y no lo ves venir',
    detail:
      'Un comentario "inocente" o una pregunta "genuina" que mata tu idea. ¿Fue casualidad o estrategia? Nunca estás seguro, y eso es lo más peligroso.',
  },
  {
    title: 'Tu palabra no tiene el peso que merece',
    detail:
      'Hablás con convicción, pero te ignoran. Otros dicen lo mismo y todos asienten. Hay una dinámica de autoridad que no estás logrando activar.',
  },
  {
    title: 'Dependés de tu intuición (y a veces falla)',
    detail:
      'Leer a la gente a "ojo" es arriesgado. Cuando te equivocás, perdés negocios, clientes y respeto. El error en este nivel sale caro.',
  },
]

export const solutionTitle = 'La solución: Un mapa visual para un mundo estratégico'

export const solutionIntro: string[] = [
  'Hemos decodificado los 48 principios de poder más influyentes de la historia para transformarlos en una herramienta de consulta rápida.',
  'No es teoría densa. Son 48 páginas ilustradas de nivel editorial diseñadas para que cada ley se entienda en 60 segundos, con ejemplos aplicados al contexto real de Argentina.',
]

export const highlightTitle =
  'Cuando activás el Código de Autoridad, empezás a notar lo invisible:'

export const highlightItems: string[] = [
  'En la reunión donde intentan silenciarte.',
  'En el cliente que usa tácticas de presión para bajar tu precio.',
  'En el colega que escala posiciones mientras otros se estancan.',
  'En los círculos donde la información es el verdadero capital.',
]

export const highlightClosing =
  'De repente, dejás de ser un observador para ser quien dirige la jugada.'

export const previewEyebrow = 'Una vista previa de tu nueva ventaja estratégica'

export const previewTitle = 'Diseño de alto nivel para decisiones de alto impacto'

export const previewSubtitle =
  'Explorá el interior de El Código de Autoridad. Cada una de las 48 leyes ha sido curada visualmente para ofrecerte claridad inmediata sin rellenos innecesarios.'

export const previewHighlight =
  'Ejemplos reales, aplicaciones prácticas y diseño editorial premium.'

export const previewCta = 'Quiero el acceso completo ahora'

export interface PreviewImage {
  src: string
  alt: string
}

export const previewImages: PreviewImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/iYWcbTnMXFF47VvJwUg4cj/Captura_de_pantalla_2026-09-08_a_la(s)_2.48.20_a._m..png',
    alt: 'Ley 42: Resolvé los conflictos de forma definitiva — lámina ilustrada con la ley en pocas palabras, ejemplo práctico y palabras clave',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nHanMk9i2r9fsUv3H9mxox/Captura_de_pantalla_2026-09-08_a_la(s)_2.48.54_a._m..png',
    alt: 'Ley 29: Planificá cada detalle — lámina ilustrada con la ley en pocas palabras, ejemplo práctico y palabras clave',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rigthBrozMJ9Y9TwCjsSbX/Captura_de_pantalla_2026-09-08_a_la(s)_2.49.20_a._m..png',
    alt: 'Ley 17: Mantené el suspenso — lámina ilustrada con la ley en pocas palabras, ejemplo práctico y palabras clave',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sjrbzkHYq9jbvKK2PHFLrz/Captura_de_pantalla_2026-09-08_a_la(s)_2.55.44_a._m..png',
    alt: 'Ley 22: Usá la táctica de la rendición — lámina ilustrada con la ley en pocas palabras, ejemplo práctico y palabras clave',
  },
]

export interface Bonus {
  tag: string
  title: string
  value: string
  description: string
}

export const bonusesTitle = 'Llevate hoy estos 5 Bonos Exclusivos (GRATIS)'

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 1',
    title: 'Mapa de Poder Personal',
    value: '$4.990',
    description:
      'Un diagnóstico visual para descubrir tu nivel actual de autoridad y las 7 señales que revelan cuándo estás cediendo poder sin darte cuenta.',
  },
  {
    tag: 'Bono 2',
    title: 'Guía Rápida: "¿Qué Ley Usar Ahora?"',
    value: '$3.490',
    description:
      'El índice táctico para situaciones críticas: "¿Mi jefe me sabotea?", "¿Tengo una negociación difícil?", "¿Quiero proyectar más respeto?".',
  },
  {
    tag: 'Bono 3',
    title: 'Checklist Anti-Errores de Autoridad',
    value: '$2.990',
    description:
      'Los 25 errores que destruyen tu presencia al instante y las 7 frases que nunca deberías decir si querés mantener el control.',
  },
  {
    tag: 'Bono 4',
    title: 'Casos Reales: Las Leyes en Argentina',
    value: '$5.490',
    description:
      'Historias reales de nuestra cultura: desde negociaciones en cafés de CABA hasta dinámicas de poder en llamadas de Zoom.',
  },
  {
    tag: 'Bono 5',
    title: 'Mini-Curso: Lectura de Personas en 48hs',
    value: '$6.990',
    description:
      'Aprendé a detectar los 12 indicadores silenciosos de quién tiene el poder real en cualquier sala antes de que digan una palabra.',
  },
]

export const bonusesTotal = '$23.950'

export const urgency = {
  title: 'Oferta de lanzamiento — solo hoy',
  body:
    'Este pack completo está disponible a este precio solo por tiempo limitado. Queremos premiar a los profesionales que toman decisiones rápidas.',
  note: 'Acceso inmediato al precio promocional.',
}

export interface Offer {
  name: string
  includes: string[]
  listPrice: string
  price: string
  note: string
  cta: string
}

export const pricingTitle = 'Tu inversión en claridad estratégica'

export const offer: Offer = {
  name: 'El Código de Autoridad + 5 Bonos Exclusivos',
  includes: [
    '48 Leyes Ilustradas (Versión Premium A4)',
    'Los 5 Bonos de Estrategia y Defensa',
    'Descarga inmediata en PDF',
    'Acceso de por vida desde cualquier dispositivo',
    'Garantía total de satisfacción',
  ],
  listPrice: '$41.950',
  price: '$14.990',
  note: 'Menos de lo que cuesta una cena, para una herramienta que redefine tu carrera.',
  cta: 'Quiero mi acceso completo ahora',
}

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
}

export const testimonialsTitle = 'Lo que dicen quienes ya ven el juego:'

export const testimonials: Testimonial[] = [
  {
    initials: 'MG',
    quote:
      'Leí el libro original pero nunca supe cómo aplicarlo. Estos resúmenes visuales son otra cosa. En 5 minutos antes de una reunión elijo mi estrategia y funciona.',
    author: 'Martín G.',
    role: 'Director de Ventas',
  },
  {
    initials: 'CM',
    quote:
      'Como mujer en un ambiente corporativo de hombres, este material me dio las gafas que me faltaban para entender las jugadas de pasillo. Imprescindible.',
    author: 'Carolina M.',
    role: 'RRHH',
  },
  {
    initials: 'DL',
    quote:
      'La mejor inversión que hice este año. La guía de casos reales argentinos es oro puro.',
    author: 'Diego L.',
    role: 'Emprendedor',
  },
]

export const guarantee = {
  title: '100% Garantía de Satisfacción de Por Vida',
  body:
    'Si en cualquier momento sentís que el material no cumple tus expectativas o no te aporta el valor que buscabas, pedís el reembolso y te devolvemos el 100% de tu dinero.',
  emphasis: 'Sin preguntas. Sin vueltas.',
  closing: 'El riesgo es todo nuestro.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿El acceso es inmediato?',
    answer: 'Sí, recibís el link de descarga en tu mail ni bien se confirma el pago.',
  },
  {
    question: '¿Puedo imprimirlo?',
    answer: 'Sí, está diseñado en alta resolución para que luzca perfecto en papel A4.',
  },
  {
    question: '¿Sirve si no leí el libro?',
    answer: 'Es ideal para vos, porque te ahorrás 500 páginas e vas directo a la aplicación práctica.',
  },
  {
    question: '¿Es un pago único?',
    answer: 'Sí. Pagás una vez y tenés el material para siempre.',
  },
]

export const finalCtaTitle =
  '¿Vas a seguir jugando a ciegas o vas a empezar a ver el tablero?'

export const finalCtaButton = 'Empezar a ver el juego ahora — $14.990'

export const footerNote =
  'Este sitio no forma parte de Meta ni Google. Los resultados dependen de la aplicación estratégica de cada usuario.'

export const footerLegal = 'El Código de Autoridad © 2026'

export const checkoutUrl = 'https://codigo-de-autoridad.impultienda.ar'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/nb7HhMpHPAQdromEMJ7A5z/mockup-.png'
